import { render, staticRenderFns } from "./studentSignCourse.vue?vue&type=template&id=ffe69860&scoped=true"
import script from "./studentSignCourse.vue?vue&type=script&lang=js"
export * from "./studentSignCourse.vue?vue&type=script&lang=js"
import style0 from "./studentSignCourse.vue?vue&type=style&index=0&id=ffe69860&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe69860",
  null
  
)

export default component.exports